import Vue, { PropType } from 'vue';
import IconBase from '../icon';
import { IconProps, SVGJson } from '../utils/types';
import useSizeProps from '../utils/use-size-props';

const element: SVGJson = {"tag":"svg","attrs":{"fill":"none","viewBox":"0 0 24 24","width":"1em","height":"1em"},"children":[{"tag":"path","attrs":{"fill":"props.filledColor","d":"M8.17134 1.01475L7 0.811035V6H16.0189C14.4259 3.55866 11.9091 1.66479 8.17134 1.01475Z"}},{"tag":"path","attrs":{"fill":"props.filledColor","d":"M17.0786 8H7V11H17.9958C17.7893 9.98461 17.4908 8.97227 17.0786 8Z"}},{"tag":"path","attrs":{"fill":"props.filledColor","d":"M18.2902 13H7V16H18.3594C18.4033 15.036 18.3868 14.0244 18.2902 13Z"}},{"tag":"path","attrs":{"fill":"props.filledColor","d":"M18.1771 18H7V21H4V23H21V21H17.508C17.7907 20.1416 18.0232 19.115 18.1771 18Z"}}]};

const SailingHotelFilled = Vue.extend<IconProps>({
  name: 'SailingHotelFilledIcon',
  functional: true,
  props: {
    size: {
      type: String,
    },
    onClick: {
      type: Function as PropType<IconProps['onClick']>,
    },
    fillColor: {
      type: [String, Array] as PropType<IconProps['fillColor']>,
    },
    strokeColor: {
      type: [String, Array] as PropType<IconProps['fillColor']>,
    },
    strokeWidth: {
      type: Number,
      default: 2
    }
  },
  render(createElement, context) {
    const { props, data } = context;
    const { size, ...otherProps } = props;

    const { className, style } = useSizeProps(size);
    const fullProps = {
      ...otherProps || {},
      id: 'sailing-hotel-filled',
      icon: element,
      staticClass: className,
      style,
    };
    data.props = fullProps;
    return createElement(IconBase, data);
  },
});

export default SailingHotelFilled;
